export default __webpack_public_path__ + "static/startup-sindh-web-banner-5108f70c690efc6ab60cb88acc63cf16.jpg";